import React from 'react';
import PropTypes from 'prop-types';
import { CHAT_ATTACHMENT_TYPE } from '../../constants/chat';
import Image from './Image';
import Document from './Document';

const NewMessageImage = ({ image, remove }) => {
  if (image.class_name === CHAT_ATTACHMENT_TYPE.IMAGE)
    return <Image image={image} remove={remove} />;
  if (image.class_name === CHAT_ATTACHMENT_TYPE.DOCUMENT)
    return <Document image={image} remove={remove} />;
  return null;
};

NewMessageImage.propTypes = {
  image: PropTypes.shape({}).isRequired,
  remove: PropTypes.func.isRequired,
};

export default NewMessageImage;



// WEBPACK FOOTER //
// ./app/javascript/common/components/NewMessageImage/NewMessageImage.js